export default __webpack_public_path__ + "static/media/WTLOGO.59273ca3.png";